import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

const Illustration: React.FC<{ title: string; className: string }> = ({ title, className }) => (
    <div className={`w-full h-48 rounded-2xl flex items-center justify-center p-4 border-2 border-dashed ${className}`}>
        <span className="text-sm font-medium">{title}</span>
    </div>
);

const PostureLesson: React.FC = () => {
    const { t } = useLanguage();

    return (
        <div className="bg-white/60 p-8 rounded-4xl shadow-lg border border-white/50">
            <h2 className="text-3xl font-bold mb-4 text-center">{t('postureLesson.title')}</h2>
            <p className="text-stone-600 text-center mb-10 max-w-2xl mx-auto">{t('postureLesson.intro')}</p>
            
            <div className="space-y-12">
                {/* Anterior Tilt */}
                <div className="grid md:grid-cols-2 gap-8 items-center">
                    <div>
                        <h3 className="text-2xl font-bold mb-3 text-accent">{t('postureLesson.anteriorTitle')}</h3>
                        <p className="text-stone-700">{t('postureLesson.anteriorDesc')}</p>
                    </div>
                    <Illustration title="Anterior Tilt" className="border-red-400 bg-red-50 text-red-700" />
                </div>
                
                {/* Posterior Tilt */}
                 <div className="grid md:grid-cols-2 gap-8 items-center">
                    <Illustration title="Posterior Tilt" className="border-blue-400 bg-blue-50 text-blue-700 md:order-last" />
                    <div>
                        <h3 className="text-2xl font-bold mb-3 text-accent">{t('postureLesson.posteriorTitle')}</h3>
                        <p className="text-stone-700">{t('postureLesson.posteriorDesc')}</p>
                    </div>
                </div>

                {/* Lateral Tilt */}
                <div className="grid md:grid-cols-2 gap-8 items-center">
                    <div>
                        <h3 className="text-2xl font-bold mb-3 text-accent">{t('postureLesson.lateralTitle')}</h3>
                        <p className="text-stone-700">{t('postureLesson.lateralDesc')}</p>
                    </div>
                    <Illustration title="Lateral Tilt" className="border-yellow-500 bg-yellow-50 text-yellow-800" />
                </div>
            </div>
        </div>
    );
};

export default PostureLesson;
